// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popShow{padding:10px;font-size:12px;border:1px solid #ddd}", ""]);
// Exports
module.exports = exports;
